import { useTranslation } from 'react-i18next'
import { CircleAlert } from 'lucide-react'
import type { OAuthFlowError } from './oauthFlow'

export function OAuthErrorCard({ error }: { error: OAuthFlowError }) {
  const { t } = useTranslation('auth')
  return (
    <div role="alert" className="flex items-start gap-3 rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-[15px]">
      <CircleAlert className="mt-0.5 h-5 w-5 shrink-0 text-destructive" aria-hidden="true" />
      <p>{t(`oauth.errors.${error}`)}</p>
    </div>
  )
}
